import api from './api';

export interface PrescriptionLineItem {
  medication: string;
  dose: string;
  quantity: string;
  unit_of_measure: string;
  price_cents: number | null;
}

export interface AmendmentShipping {
  carrier_name: string | null;
  service_name: string | null;
  cost_cents: number;
  original_cost_cents: number;
  is_free_shipment: boolean;
}

export interface AmendmentData {
  clinic_name: string | null;
  program_name: string | null;
  original_amount_cents: number;
  prescription_amount_cents: number;
  delta_cents: number;
  pct_change: number;
  created_at: string;
  auto_accept_at: string;
  payment_status: string;
  line_items: PrescriptionLineItem[];
  shipping: AmendmentShipping | null;
}

export interface AcceptResult {
  new_amount_cents: number;
  delta_charged_cents: number;
  payment_status: string;
}

export interface DeclineResult {
  refund_amount_cents: number;
  payment_status: string;
  order_status: string;
}

export interface CancelResult {
  refund_amount_cents: number;
  payment_status: string;
  order_status: string;
}

const guidedOrderAmendmentPublicService = {
  getAmendment: (token: string) =>
    api.get<{ success: boolean; data: AmendmentData }>(`/public/guided-order-amendment/${token}`).then(r => r.data),

  acceptAmendment: (token: string) =>
    api.post<{ success: boolean; message: string; data: AcceptResult }>(`/public/guided-order-amendment/${token}/accept`).then(r => r.data),

  declineAmendment: (token: string, reason?: string) =>
    api.post<{ success: boolean; message: string; data: DeclineResult }>(`/public/guided-order-amendment/${token}/decline`, { reason }).then(r => r.data),

  cancelOrder: (token: string) =>
    api.post<{ success: boolean; message: string; data: CancelResult }>(`/public/guided-order-amendment/${token}/cancel`).then(r => r.data),
};

export default guidedOrderAmendmentPublicService;
